export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    DateTime: any;
};

export type AbbaTargetExperiment = {
    __typename?: "AbbaTargetExperiment";
    buckets: Maybe<Array<Maybe<AbbaTargetExperimentBucket>>>;
    endTime: Maybe<Scalars["DateTime"]>;
    experimentId: Maybe<Scalars["String"]>;
    locked: Maybe<Scalars["Boolean"]>;
    population: Maybe<Scalars["Float"]>;
    startTime: Maybe<Scalars["DateTime"]>;
};

export type AbbaTargetExperimentBucket = {
    __typename?: "AbbaTargetExperimentBucket";
    bucketId: Maybe<Scalars["String"]>;
    config: Maybe<Scalars["String"]>;
};

/** ABBA test variant */
export type AbbaVariant = {
    __typename?: "AbbaVariant";
    ab_config_key: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    page_name: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
    variation: Maybe<Scalars["String"]>;
};

export type AdTargeting = {
    __typename?: "AdTargeting";
    adCode: Maybe<Scalars["String"]>;
    currentResource: Maybe<Scalars["String"]>;
    kwl: Maybe<Array<Maybe<Scalars["String"]>>>;
    ni: Maybe<Array<Maybe<Scalars["String"]>>>;
    page: Maybe<Scalars["String"]>;
    sites: Maybe<Array<Maybe<Scalars["String"]>>>;
    suid: Maybe<Scalars["String"]>;
    tagr: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export enum AspectRatio {
    Aspect_1_1 = "ASPECT_1_1",
    Aspect_9_16 = "ASPECT_9_16",
    Aspect_16_9 = "ASPECT_16_9",
}

export type AssetMedia = {
    __typename?: "AssetMedia";
    assetType: Maybe<Scalars["String"]>;
    caption: Maybe<Scalars["String"]>;
    credit: Maybe<Scalars["String"]>;
    hedAndDekPosition: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    kind: Maybe<Scalars["String"]>;
};

export type Audio = {
    __typename?: "Audio";
    allowedOnWeb: Maybe<Scalars["Boolean"]>;
    codec: Maybe<Scalars["String"]>;
    description: Maybe<Scalars["String"]>;
    duration: Maybe<Scalars["String"]>;
    extension: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    image: Maybe<Image>;
    key: Maybe<Scalars["String"]>;
    publishedAt: Maybe<Scalars["Int"]>;
    rawUrl: Maybe<Scalars["String"]>;
    syndicated: Maybe<Scalars["Boolean"]>;
    systemFolderName: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
};

export type AuthorSession = {
    __typename?: "AuthorSession";
    authorSessionId: Scalars["String"];
    authorSessionSlug: Scalars["String"];
    chatChannelId: Maybe<Scalars["String"]>;
    eventEndTimestamp: Maybe<Scalars["DateTime"]>;
    eventStartTimestamp: Maybe<Scalars["DateTime"]>;
    groupId: Maybe<Scalars["String"]>;
    publishTokenId: Maybe<Scalars["Int"]>;
    status: Maybe<Scalars["String"]>;
    story: Maybe<Story>;
    title: Maybe<Scalars["String"]>;
};

export type AuthorSessionList = {
    __typename?: "AuthorSessionList";
    sessions: Array<Maybe<AuthorSession>>;
    total: Scalars["Int"];
};

export type AutoSummary = {
    __typename?: "AutoSummary";
    text: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
    version: Maybe<Scalars["String"]>;
};

export type Autofill = {
    __typename?: "Autofill";
    args: Maybe<Scalars["String"]>;
    type: Maybe<AutofillType>;
};

export enum AutofillType {
    Personalized = "PERSONALIZED",
    Popular = "POPULAR",
}

export type Award = {
    __typename?: "Award";
    awardName: Maybe<Scalars["String"]>;
    date: Maybe<Scalars["String"]>;
    text: Maybe<Scalars["String"]>;
};

export type Awards = {
    __typename?: "Awards";
    awards: Maybe<Array<Maybe<Award>>>;
    numAwards: Maybe<Scalars["Int"]>;
    numPublications: Maybe<Scalars["Int"]>;
    publications: Maybe<Array<Maybe<Publication>>>;
};

export type Bitrate = {
    __typename?: "Bitrate";
    audio: Maybe<Scalars["Int"]>;
    video: Maybe<Scalars["Int"]>;
};

export type BoardMembership = {
    __typename?: "BoardMembership";
    companyName: Maybe<Scalars["String"]>;
    tenure: Maybe<Scalars["String"]>;
    ticker: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    webTicker: Maybe<Scalars["String"]>;
};

export enum Brand {
    Business = "BUSINESS",
    Businessweek = "BUSINESSWEEK",
    Citylab = "CITYLAB",
    Cojp = "COJP",
    Crypto = "CRYPTO",
    Economics = "ECONOMICS",
    Equality = "EQUALITY",
    Gadfly = "GADFLY",
    Green = "GREEN",
    Industries = "INDUSTRIES",
    Markets = "MARKETS",
    MarketsMagazine = "MARKETS_MAGAZINE",
    Politics = "POLITICS",
    Pursuits = "PURSUITS",
    Quicktake = "QUICKTAKE",
    Sponsored = "SPONSORED",
    Technology = "TECHNOLOGY",
    View = "VIEW",
    Wealth = "WEALTH",
    WeekendEdition = "WEEKEND_EDITION",
    WorkShift = "WORK_SHIFT",
    World = "WORLD",
}

/** Sponsored Campaign Information. */
export type Campaign = {
    __typename?: "Campaign";
    /** Advertiser ID */
    advertiserId: Maybe<Scalars["String"]>;
    /** Date and time that campaign ends */
    endsAt: Maybe<Scalars["DateTime"]>;
    /** Campaign ID */
    id: Maybe<Scalars["String"]>;
    /** Image for advertiser logo */
    logo: Maybe<Image>;
    /** Full campaign title */
    name: Maybe<Scalars["String"]>;
    /** Date and time that campaign starts */
    startsAt: Maybe<Scalars["DateTime"]>;
    /** URL that advertiser logo links to */
    url: Maybe<Scalars["String"]>;
};

export type Career = {
    __typename?: "Career";
    organization: Maybe<Scalars["String"]>;
    ticker: Maybe<Scalars["String"]>;
    timespan: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    webTicker: Maybe<Scalars["String"]>;
};

export type Chart = {
    __typename?: "Chart";
    aspectRatio: Maybe<Scalars["String"]>;
    /** The system that was used to create this chart. Either toaster, G, or unknown. */
    creator: ChartCreator;
    footnote: Maybe<Scalars["String"]>;
    html: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    offRail: Maybe<Scalars["Boolean"]>;
    /** Either "image" or "iframe" the API provides a default render format */
    renderFormat: ChartRenderFormat;
    /** Height of chart when rendered at default body width (usually 740px). */
    renderHeight: Maybe<Scalars["Int"]>;
    /** Prerendered charts for responsive mobile/widget display */
    responsiveImages: Maybe<ChartResponsiveImageSet>;
    source: Maybe<Scalars["String"]>;
    subtitle: Maybe<Scalars["String"]>;
    /** For G charts, this is the terminal function that will display the chart */
    terminalFunction: Maybe<Scalars["String"]>;
    theme: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
    uuid: Maybe<Scalars["String"]>;
};

export enum ChartCreator {
    G = "G",
    Toaster = "TOASTER",
    Unknown = "UNKNOWN",
}

export enum ChartRenderFormat {
    Iframe = "IFRAME",
    Image = "IMAGE",
}

export type ChartResponsiveImage = {
    __typename?: "ChartResponsiveImage";
    canvasWidth: Maybe<Scalars["Int"]>;
    height: Maybe<Scalars["Int"]>;
    id: Maybe<Scalars["String"]>;
    /** Bpix image URL allowing custom thumbnail sizing */
    url: Maybe<Scalars["String"]>;
    width: Maybe<Scalars["Int"]>;
};

export type ChartResponsiveImageSet = {
    __typename?: "ChartResponsiveImageSet";
    dark: Maybe<ChartResponsiveImage>;
    default: Maybe<ChartResponsiveImage>;
    large: Maybe<ChartResponsiveImage>;
    light: Maybe<ChartResponsiveImage>;
    mobile: Maybe<ChartResponsiveImage>;
    widget: Maybe<ChartResponsiveImage>;
};

export type Codec = {
    __typename?: "Codec";
    audio: Maybe<Scalars["String"]>;
    video: Maybe<Scalars["String"]>;
};

/** The Collection object type */
export type Collection = {
    __typename?: "Collection";
    navLinks: Maybe<Array<Maybe<NavLink>>>;
    slug: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    titleLink: Maybe<Scalars["String"]>;
};

/** Collections object type */
export type Collections = {
    __typename?: "Collections";
    newsletterEntitlements: Maybe<Array<Maybe<Scalars["String"]>>>;
    record: Maybe<Collection>;
    recordId: Maybe<Scalars["String"]>;
    weekend: Maybe<Collection>;
    weekendId: Maybe<Scalars["String"]>;
};

/** Collections object type */
export type CollectionsWeekendArgs = {
    latest: InputMaybe<Scalars["Boolean"]>;
};

export type Column = {
    __typename?: "Column";
    modules: Maybe<Array<Maybe<CurationModule>>>;
};

export type ColumnModulesArgs = {
    skipModuleExpansion?: InputMaybe<Scalars["Boolean"]>;
};

export type Company = {
    __typename?: "Company";
    id: Maybe<Scalars["String"]>;
    longName: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
};

/** The fields id, type, directScore, and derivedScore are passed through. Querying for the name field will incur an additional cost, as a network request will be made to resolve it. */
export type ContentTag = {
    __typename?: "ContentTag";
    derivedScore: Maybe<Scalars["Float"]>;
    directScore: Maybe<Scalars["Float"]>;
    id: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
};

export type ContentTagsFilter = {
    id: InputMaybe<Scalars["String"]>;
    type: InputMaybe<Scalars["String"]>;
};

export type ContentTagsSort = {
    order: InputMaybe<SortOrder>;
    scoreType: InputMaybe<TagScoreType>;
};

export enum ContentType {
    Article = "article",
    BreakingNews = "breaking_news",
    Feature = "feature",
    ImpactScorecard = "impact_scorecard",
    Letter = "letter",
    NewsletterCampaign = "newsletter_campaign",
    Slideshow = "slideshow",
    Storythread = "storythread",
}

export type ContextItem = {
    __typename?: "ContextItem";
    id: Maybe<Scalars["Int"]>;
    languages: Maybe<Array<Maybe<Language>>>;
};

export enum Criteria {
    PercentDown = "PERCENT_DOWN",
    PercentUp = "PERCENT_UP",
    Volume = "VOLUME",
}

export type CuratedItem = CuratedLink | Newsletter | Security | Story;

export type CuratedLink = {
    __typename?: "CuratedLink";
    /** Override the image credit in the image */
    creditCurationOverride: Maybe<Scalars["String"]>;
    curatedAt: Maybe<Scalars["DateTime"]>;
    /** URL for an embedded webpage attachments */
    embedUrl: Maybe<Scalars["String"]>;
    extraTags: Maybe<ExtraTags>;
    headline: Maybe<Scalars["String"]>;
    html: Maybe<Scalars["String"]>;
    label: Maybe<Scalars["String"]>;
    /** Text value for label from list in edit dash for lineup */
    labelDropdown: Maybe<Scalars["String"]>;
    listId: Maybe<Scalars["String"]>;
    /** Text value for the kind of livestream */
    livestream: Maybe<Scalars["String"]>;
    mainTout: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    originalType: Maybe<Scalars["String"]>;
    page: Maybe<Scalars["String"]>;
    position: Maybe<Scalars["String"]>;
    related: Maybe<RelatedStories>;
    /** Optional title for related items */
    relatedTitle: Maybe<Scalars["String"]>;
    site: Maybe<Scalars["String"]>;
    slideoutTout: Maybe<Scalars["String"]>;
    /** Time range of price movements for interactive chart to show (e.g. ONE_MONTH) */
    snapshotDuration: Maybe<Scalars["String"]>;
    /** End date for a chart intraday series */
    snapshotEndDate: Maybe<Scalars["String"]>;
    /** Start date for a chart intraday series */
    snapshotStartDate: Maybe<Scalars["String"]>;
    /** Terminal ticker to display an interactive chart with the story (e.g. TSLA:US) */
    snapshotTicker: Maybe<Scalars["String"]>;
    /** Optional headline for the snapshot chart */
    snapshotTitle: Maybe<Scalars["String"]>;
    subTout: Maybe<Scalars["String"]>;
    summary: Maybe<Scalars["String"]>;
    /** Text overwrite value for item labels in lineup. */
    textLabel: Maybe<Scalars["String"]>;
    thumbnail: Maybe<Image>;
    title: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
    /** item-level display distinction. */
    variation: Maybe<Scalars["String"]>;
    /** Video added to the story item in Edit Dash */
    videoCurationOverride: Maybe<Video>;
    zone: Maybe<Scalars["String"]>;
    zoneLayout: Maybe<Scalars["String"]>;
};

export type CuratedLinkThumbnailArgs = {
    imageQuality: InputMaybe<Scalars["Int"]>;
};

export type Curation = {
    __typename?: "Curation";
    /** Page level brand used to apply front-end themes */
    brand: Maybe<Scalars["String"]>;
    description: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    module: Maybe<CurationModule>;
    modules: Maybe<Array<Maybe<CurationModule>>>;
    /** The url path as defined in EditDash */
    path: Maybe<Scalars["String"]>;
    /** SEO image for the page */
    seoImage: Maybe<Image>;
    /** Page level theme */
    theme: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};

export type CurationModuleArgs = {
    id: Scalars["String"];
};

export type CurationModule = {
    __typename?: "CurationModule";
    ab_config_key: Maybe<Scalars["String"]>;
    ab_variants: Maybe<Array<Maybe<AbbaVariant>>>;
    adPositionIncrement: Maybe<Scalars["String"]>;
    adPositionIncremented: Maybe<Scalars["Boolean"]>;
    adSpacing: Maybe<Scalars["String"]>;
    adType: Maybe<Scalars["String"]>;
    altLabel: Maybe<Scalars["String"]>;
    altLabelUrl: Maybe<Scalars["String"]>;
    autofill: Maybe<Scalars["Boolean"]>;
    autofillData: Maybe<Autofill>;
    autoplay: Maybe<Scalars["Boolean"]>;
    /**
     *
     *         This field allows for dynamic boolean attributes. Usage:
     *           modules {
     *             enabled: booleanVariable(id: "enabled")
     *           }
     *
     */
    booleanVariable: Maybe<Scalars["Boolean"]>;
    callToAction: Maybe<Scalars["String"]>;
    callToActionHyperlink: Maybe<Scalars["String"]>;
    content: Maybe<Scalars["String"]>;
    duplicateOf: Maybe<Scalars["String"]>;
    /** Terminal Tickers curated to a module */
    editorialTickers: Maybe<Array<Maybe<Scalars["String"]>>>;
    editorialTitle: Maybe<Scalars["String"]>;
    embedHeight: Maybe<Scalars["String"]>;
    embedLiveStream: Maybe<Scalars["String"]>;
    embedUrl: Maybe<Scalars["String"]>;
    facebook_account: Maybe<Scalars["String"]>;
    grouping: Maybe<Scalars["String"]>;
    html: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    image: Maybe<Image>;
    imageSource: Maybe<Scalars["String"]>;
    instagram_account: Maybe<Scalars["String"]>;
    items: Maybe<Array<Maybe<CuratedItem>>>;
    label: Maybe<Scalars["String"]>;
    labelUrl: Maybe<Scalars["String"]>;
    layout: Maybe<Scalars["String"]>;
    linkedin_account: Maybe<Scalars["String"]>;
    list_id: Maybe<Scalars["String"]>;
    mobileImage: Maybe<Image>;
    modules: Maybe<Array<Maybe<CurationModule>>>;
    name: Maybe<Scalars["String"]>;
    navItems: Maybe<Scalars["String"]>;
    /** For use with nested modules, to determine what variation type (navigation, multimedia, etc) they are for use in the parent component . */
    nestedVariation: Maybe<Scalars["String"]>;
    nextItemOffset: Maybe<Scalars["Int"]>;
    pageId: Maybe<Scalars["String"]>;
    position: Maybe<Scalars["String"]>;
    ratePlan2ImageOverride: Maybe<Image>;
    ratePlans: Maybe<Array<Maybe<RatePlan>>>;
    skipDedup: Maybe<Scalars["Boolean"]>;
    sponsored: Maybe<Scalars["Boolean"]>;
    /**
     * @deprecated
     *         This was an improper implementation. Curations can also include
     *         other types of items such as "external_link". Please use "items"
     *         instead.
     *
     */
    stories: Maybe<Array<Maybe<Story>>>;
    storyIdsToExclude: Maybe<Scalars["String"]>;
    streamId: Maybe<Scalars["String"]>;
    subtitle: Maybe<Scalars["String"]>;
    /** Country code to specify a country to limit the module's visibility to */
    targetCountryCode: Maybe<Scalars["String"]>;
    theme: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    tracking: Maybe<Tracking>;
    twitter_account: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
    updatedAt: Maybe<Scalars["DateTime"]>;
    /**
     *
     *         This field allows for dynamic attributes. Usage:
     *           modules {
     *             text: variable(id: 'text')
     *             color: variable(id: 'color')
     *           }
     *
     */
    variable: Maybe<Scalars["String"]>;
    variation: Maybe<Scalars["String"]>;
    video: Maybe<Video>;
    youtube_account: Maybe<Scalars["String"]>;
    zone: Maybe<Scalars["String"]>;
};

export type CurationModuleBooleanVariableArgs = {
    id: Scalars["String"];
};

export type CurationModuleVariableArgs = {
    id: Scalars["String"];
};

export type DateRange = {
    from: InputMaybe<Scalars["DateTime"]>;
    to: InputMaybe<Scalars["DateTime"]>;
};

export type DateTimeValue = {
    __typename?: "DateTimeValue";
    dateTime: Maybe<Scalars["String"]>;
    value: Maybe<Scalars["Float"]>;
};

/** document type for web display */
export type Document = {
    __typename?: "Document";
    id: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
};

export type Education = {
    __typename?: "Education";
    schools: Maybe<Array<Maybe<School>>>;
};

export type Episode = {
    __typename?: "Episode";
    encoderGroupId: Maybe<Scalars["Int"]>;
    enpsGridId: Maybe<Scalars["String"]>;
    episodeDescription: Maybe<Scalars["String"]>;
    episodeEndTime: Maybe<Scalars["DateTime"]>;
    episodeEndTimeLocal: Maybe<Scalars["DateTime"]>;
    episodeHasArchive: Maybe<Scalars["Int"]>;
    episodeMrcId: Maybe<Scalars["String"]>;
    episodeNiCode: Maybe<Array<Maybe<Scalars["String"]>>>;
    episodeStartTime: Maybe<Scalars["DateTime"]>;
    episodeStartTimeLocal: Maybe<Scalars["DateTime"]>;
    episodeTitle: Maybe<Scalars["String"]>;
    eventLinkId: Maybe<Scalars["String"]>;
    eventType: Maybe<Scalars["String"]>;
    mrcRegion: Maybe<Scalars["String"]>;
    showMrcId: Maybe<Scalars["String"]>;
    thumbnail: Maybe<Image>;
};

export enum ExchangeMoversDirection {
    Down = "DOWN",
    Up = "UP",
}

export enum ExchangeMoversPeriod {
    FifteenMinutes = "FIFTEEN_MINUTES",
    FiveMinutes = "FIVE_MINUTES",
    Hour = "HOUR",
    Intraday = "INTRADAY",
    OneMinute = "ONE_MINUTE",
    Today = "TODAY",
    Yesterday = "YESTERDAY",
}

export enum ExchangeMoversTableType {
    PriceChange = "PRICE_CHANGE",
    PricePctChange = "PRICE_PCT_CHANGE",
    TradeValueChange = "TRADE_VALUE_CHANGE",
    VolumeChange = "VOLUME_CHANGE",
    VolumeIncrease_1D = "VOLUME_INCREASE_1D",
    VolumeIncrease_5D = "VOLUME_INCREASE_5D",
    VolumeIncrease_20D = "VOLUME_INCREASE_20D",
}

export enum ExecutionMode {
    And = "AND",
    Or = "OR",
}

/** Additional tags added through curation. */
export type ExtraTags = {
    __typename?: "ExtraTags";
    /** Used to manually associate tickers with a story */
    terminalTickers: Maybe<Array<Maybe<Tag>>>;
};

export type FloatRange = {
    max: InputMaybe<Scalars["Float"]>;
    min: InputMaybe<Scalars["Float"]>;
};

export type FundHolding = {
    __typename?: "FundHolding";
    change: Maybe<Scalars["Float"]>;
    filingDate: Maybe<Scalars["String"]>;
    marketValue: Maybe<Scalars["Float"]>;
    name: Maybe<Scalars["String"]>;
    percentNet: Maybe<Scalars["Float"]>;
    position: Maybe<Scalars["Float"]>;
    security: Maybe<Scalars["String"]>;
    ticker: Maybe<Scalars["String"]>;
};

export type FxFixings = {
    __typename?: "FxFixings";
    id: Maybe<Scalars["String"]>;
    rate: Maybe<Scalars["Float"]>;
};

export enum GeoEntityType {
    Countries = "COUNTRIES",
    Regions = "REGIONS",
}

export type Guest = {
    __typename?: "Guest";
    companiesMentioned: Maybe<Array<Maybe<Scalars["String"]>>>;
    encoderGroupId: Maybe<Scalars["Int"]>;
    eventEndTime: Maybe<Scalars["DateTime"]>;
    eventLinkId: Maybe<Scalars["String"]>;
    eventStartTime: Maybe<Scalars["DateTime"]>;
    guest: Maybe<Person>;
    guestCompanyName: Maybe<Scalars["String"]>;
    guestCompanyTicker: Maybe<Scalars["String"]>;
    guestEndTime: Maybe<Scalars["DateTime"]>;
    guestEndTimeLocal: Maybe<Scalars["DateTime"]>;
    guestName: Maybe<Scalars["String"]>;
    guestSource: Maybe<Scalars["String"]>;
    guestStartTime: Maybe<Scalars["DateTime"]>;
    guestStartTimeLocal: Maybe<Scalars["DateTime"]>;
    guestStatusId: Maybe<Scalars["Int"]>;
    guestTitle: Maybe<Scalars["String"]>;
    guestUpdateTime: Maybe<Scalars["DateTime"]>;
    guestUpdateUuid: Maybe<Scalars["Int"]>;
    interviewTopics: Maybe<Array<Maybe<Scalars["String"]>>>;
    peopleMentioned: Maybe<Array<Maybe<Scalars["String"]>>>;
    thumbnail: Maybe<Image>;
};

export enum IdType {
    Avmm = "AVMM",
    Bmmr = "BMMR",
    Ooyala = "OOYALA",
}

export type Iframe = {
    __typename?: "Iframe";
    dimension: Maybe<IframeDimension>;
    html: Maybe<Scalars["String"]>;
    meta: Maybe<IframeMeta>;
    rel: Maybe<Array<Maybe<Scalars["String"]>>>;
    url: Maybe<Scalars["String"]>;
};

export type IframeDimension = {
    __typename?: "IframeDimension";
    aspectRatio: Maybe<Scalars["Float"]>;
    height: Maybe<Scalars["Int"]>;
    maxHeight: Maybe<Scalars["Int"]>;
    maxWidth: Maybe<Scalars["Int"]>;
    minHeight: Maybe<Scalars["Int"]>;
    minWidth: Maybe<Scalars["Int"]>;
    width: Maybe<Scalars["Int"]>;
};

export type IframeMeta = {
    __typename?: "IframeMeta";
    author: Maybe<Scalars["String"]>;
    author_url: Maybe<Scalars["String"]>;
    canonical: Maybe<Scalars["String"]>;
    description: Maybe<Scalars["String"]>;
    media: Maybe<Scalars["String"]>;
    site: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};

export type Image = {
    __typename?: "Image";
    /** Constructed alt string for alt text */
    alt: Maybe<Scalars["String"]>;
    caption: Maybe<Scalars["String"]>;
    credit: Maybe<Scalars["String"]>;
    description: Maybe<Scalars["String"]>;
    desktop: Maybe<AssetMedia>;
    height: Maybe<Scalars["Int"]>;
    id: Maybe<Scalars["String"]>;
    /** OK to syndicate */
    isSyndicationPortal: Maybe<Scalars["Boolean"]>;
    mobile: Maybe<AssetMedia>;
    origHeight: Maybe<Scalars["Int"]>;
    origWidth: Maybe<Scalars["Int"]>;
    /** Provides photographer credits */
    photoCredit: Maybe<Scalars["String"]>;
    placement: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Helps to determine syndicate */
    privilegeValue: Maybe<Scalars["String"]>;
    publishedAt: Maybe<Scalars["Int"]>;
    size: Maybe<Scalars["String"]>;
    source: Maybe<Scalars["String"]>;
    submitAppId: Maybe<Scalars["String"]>;
    svgFile: Maybe<Scalars["String"]>;
    themes: Maybe<Array<Maybe<Theme>>>;
    title: Maybe<Scalars["String"]>;
    treatment: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
    width: Maybe<Scalars["Int"]>;
};

export type ImageUrlArgs = {
    useWebP: InputMaybe<Scalars["Boolean"]>;
};

export type IntradayRangeValue = {
    __typename?: "IntradayRangeValue";
    end: Maybe<Scalars["String"]>;
    start: Maybe<Scalars["String"]>;
};

export type IntradaySeriesValue = {
    __typename?: "IntradaySeriesValue";
    range: Maybe<IntradayRangeValue>;
    series: Maybe<Array<Maybe<DateTimeValue>>>;
};

export type Label = {
    __typename?: "Label";
    id: Maybe<Scalars["Int"]>;
    text: Maybe<Scalars["String"]>;
};

export type Language = {
    __typename?: "Language";
    id: Maybe<Scalars["Int"]>;
    labels: Maybe<Array<Maybe<Label>>>;
};

export type Lede = Image | Video;

export type LineupCuration = {
    __typename?: "LineupCuration";
    /** Page level brand used to apply front-end themes */
    brand: Maybe<Scalars["String"]>;
    description: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    /** Page level meta image ID */
    image: Maybe<Image>;
    lineupModule: Maybe<CurationModule>;
    /** @deprecated Use lineupModule instead for a lineupCuration */
    modules: Maybe<Array<Maybe<CurationModule>>>;
    /** The newsletter title to apply for registrations */
    newsletter: Maybe<Scalars["String"]>;
    /** The url path as defined in EditDash */
    path: Maybe<Scalars["String"]>;
    /** SEO title defined in Editdash */
    seoTitle: Maybe<Scalars["String"]>;
    /** Page level theme */
    theme: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    zones: Maybe<Array<Maybe<Zone>>>;
};

export type LineupCurationLineupModuleArgs = {
    id: Scalars["String"];
    paginationOffset: InputMaybe<Scalars["Int"]>;
    siteForModule: SiteForModule;
    state: InputMaybe<PublishedState>;
};

/** ALIV live blog posts */
export type LiveBlogPost = {
    __typename?: "LiveBlogPost";
    approvedAt: Maybe<Scalars["String"]>;
    content: Maybe<Rsf>;
    contributor: Maybe<Person>;
    id: Maybe<Scalars["String"]>;
    iframes: Maybe<Array<Maybe<Iframe>>>;
    images: Maybe<Array<Maybe<Image>>>;
    /** Aliases the "content" attribute to keypoints from the underlying keypoint post */
    postContent: Maybe<Rsf>;
    reverseIndex: Maybe<Scalars["Int"]>;
    updatedAt: Maybe<Scalars["String"]>;
    videos: Maybe<Array<Maybe<Video>>>;
};

/** ALIV live blog posts */
export type LiveBlogPostImagesArgs = {
    imageQuality: InputMaybe<Scalars["Int"]>;
    includeImageBlobMetadata: InputMaybe<Scalars["Boolean"]>;
    includePhotoCredit: InputMaybe<Scalars["Boolean"]>;
    themedOnly: InputMaybe<Scalars["Boolean"]>;
};

/** ALIV live blog posts */
export type LiveBlogPostVideosArgs = {
    idType: InputMaybe<IdType>;
    includeRenditions: InputMaybe<Scalars["Boolean"]>;
    includeTranscript: InputMaybe<Scalars["Boolean"]>;
};

export type LiveSchedule = {
    __typename?: "LiveSchedule";
    episodeGuests: Maybe<Array<Maybe<Guest>>>;
    episodeInfo: Maybe<Episode>;
    showInfo: Maybe<Show>;
};

/** ALIV liveblogs */
export type Liveblog = {
    __typename?: "Liveblog";
    closedAt: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    keypoints: Maybe<Array<Maybe<LiveBlogPost>>>;
    posts: Maybe<Array<Maybe<LiveBlogPost>>>;
    startAt: Maybe<Scalars["String"]>;
    state: Maybe<Scalars["String"]>;
    summary: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    updatedAt: Maybe<Scalars["String"]>;
};

/** ALIV liveblogs */
export type LiveblogKeypointsArgs = {
    after?: InputMaybe<Scalars["Boolean"]>;
    cursorId: InputMaybe<Scalars["String"]>;
    from?: InputMaybe<Scalars["Int"]>;
    includeCursor?: InputMaybe<Scalars["Boolean"]>;
    limit?: InputMaybe<Scalars["Int"]>;
};

/** ALIV liveblogs */
export type LiveblogPostsArgs = {
    after?: InputMaybe<Scalars["Boolean"]>;
    cursorId: InputMaybe<Scalars["String"]>;
    from?: InputMaybe<Scalars["Int"]>;
    includeCursor?: InputMaybe<Scalars["Boolean"]>;
    limit?: InputMaybe<Scalars["Int"]>;
};

export enum Locale {
    En = "en",
    Ja = "ja",
}

export enum LocaleType {
    En = "EN",
    Ja = "JA",
}

export type Magazine = {
    __typename?: "Magazine";
    coverImage: Maybe<Image>;
    date: Maybe<Scalars["String"]>;
    displayDate: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    modules: Maybe<Array<Maybe<MagazineSection>>>;
    title: Maybe<Scalars["String"]>;
};

export enum MagazineBrand {
    BusinessWeek = "BUSINESS_WEEK",
    Green = "GREEN",
    Markets = "MARKETS",
}

export type MagazineSection = {
    __typename?: "MagazineSection";
    items: Maybe<Array<Maybe<Story>>>;
    title: Maybe<Scalars["String"]>;
};

/** Magazine specific fields. */
export type MagazineStoryData = {
    __typename?: "MagazineStoryData";
    /** Strap */
    displayStrap: Maybe<Scalars["String"]>;
    /** Print magazine headline */
    headlineShort: Maybe<Scalars["String"]>;
    /** Magazine page number */
    pageNumber: Maybe<Scalars["Int"]>;
    /** Magazine bottom line */
    postscript: Maybe<Scalars["String"]>;
    /** Magazine quote */
    quote: Maybe<Scalars["String"]>;
    /** Magazine section */
    section: Maybe<Scalars["String"]>;
    /** Article deck */
    shortDeck: Maybe<Scalars["String"]>;
    /** Type of magazine */
    type: Maybe<Scalars["String"]>;
};

export type Memberships = {
    __typename?: "Memberships";
    boardMemberships: Maybe<Array<Maybe<BoardMembership>>>;
    otherMemberships: Maybe<Array<Maybe<OtherMembership>>>;
};

/** Site specific meta fields. */
export type Meta = {
    __typename?: "Meta";
    /** Whether to make the story free in Apple News businessweek channel. */
    appleNewsFree: Maybe<Scalars["Boolean"]>;
    /** Article body background color */
    background: Maybe<Scalars["String"]>;
    /** Cobrand name, if available */
    cobrand: Maybe<Scalars["String"]>;
    /** Whether to exclude the story from the businessweek paywall. */
    excludeFromPaywall: Maybe<Scalars["Boolean"]>;
    /** Whether it is a half tile story. */
    halfTile: Maybe<Scalars["Boolean"]>;
    /** Inline assets that should be hidden on web. */
    hiddenInlineAttachments: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Whether to include a page in paywall */
    isMetered: Maybe<Scalars["Boolean"]>;
    /**
     * Whether it is a magazine article. Deprecated
     * @deprecated
     *             Use "magazine" top-level object presence instead of relying on this attribute.
     *
     */
    magazine: Maybe<Scalars["Boolean"]>;
    /** Slugified id of a given newsletter */
    newsletterSlug: Maybe<Scalars["String"]>;
    /** Override for newsletter signup tout label */
    newsletterToutLabel: Maybe<Scalars["String"]>;
    /** Whether to override the Aliv headline on web with headline entered in Wolf */
    overrideAlivHeadline: Maybe<Scalars["Boolean"]>;
    /** Display the registration wall. */
    registrationWall: Maybe<Scalars["Boolean"]>;
    /** Whether to show market tickers */
    showMarketTickers: Maybe<Scalars["Boolean"]>;
    /** Whether to suppress the disqus comments on the story. */
    suppressComments: Maybe<Scalars["Boolean"]>;
    /** ID of the corresponding ALIV blog. Liveblog only */
    terminalBlogId: Maybe<Scalars["String"]>;
    /** Theme of the story such as dark or light. */
    theme: Maybe<Scalars["String"]>;
};

/** Metadata fields. */
export type Metadata = {
    __typename?: "Metadata";
    /**
     *
     *         This field allows for dynamic variable. Usage:
     *           metadata {
     *             newField: variable(id: 'newField')
     *           }
     *
     */
    variable: Maybe<Scalars["String"]>;
};

/** Metadata fields. */
export type MetadataVariableArgs = {
    id: Scalars["String"];
};

export type Metatext = {
    __typename?: "Metatext";
    /** HTML Text. May include html entities and nodes */
    html: Maybe<Scalars["String"]>;
    /** Metatag text. For use only within the head. */
    seo: Maybe<Scalars["String"]>;
    /** Plain text. */
    text: Maybe<Scalars["String"]>;
};

export type MinScore = {
    scoreType: InputMaybe<TagScoreType>;
    tagType: InputMaybe<Scalars["String"]>;
    value: InputMaybe<Scalars["Float"]>;
};

export type NavLink = {
    __typename?: "NavLink";
    customUrl: Maybe<Scalars["String"]>;
    story: Maybe<Story>;
    title: Maybe<Scalars["String"]>;
};

/** Newsletter */
export type Newsletter = {
    __typename?: "Newsletter";
    active: Maybe<Scalars["Boolean"]>;
    brands: Maybe<Array<Maybe<Scalars["String"]>>>;
    credits: Maybe<Array<Maybe<Person>>>;
    description: Maybe<Scalars["String"]>;
    fromEmail: Maybe<Scalars["String"]>;
    fromEmailName: Maybe<Scalars["String"]>;
    homepageDisplay: Maybe<NewsletterHomepageDisplay>;
    images: Maybe<Array<Maybe<Image>>>;
    language: Maybe<Scalars["String"]>;
    legacySignUpList: Maybe<Scalars["String"]>;
    nonSubscriberSignUpList: Maybe<Scalars["String"]>;
    offerPageUrl: Maybe<Scalars["String"]>;
    primaryBrand: Maybe<Scalars["String"]>;
    sampleUrl: Maybe<Scalars["String"]>;
    signUpList: Maybe<Scalars["String"]>;
    slug: Maybe<Scalars["String"]>;
    subscriptionEntitlements: Maybe<Array<Maybe<Scalars["String"]>>>;
    subscriptionType: Maybe<Scalars["String"]>;
    tags: Maybe<Array<Maybe<NewsletterTag>>>;
    title: Maybe<Scalars["String"]>;
};

export type NewsletterHomepageDisplay = {
    __typename?: "NewsletterHomepageDisplay";
    cardHeadline: Maybe<Scalars["String"]>;
    eyebrow: Maybe<Scalars["String"]>;
};

export type NewsletterTag = {
    __typename?: "NewsletterTag";
    id: Maybe<Scalars["String"]>;
    label: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
};

export type NiCodes = {
    __typename?: "NiCodes";
    id: Maybe<Scalars["String"]>;
    role: Maybe<Scalars["String"]>;
    score: Maybe<Scalars["Float"]>;
};

export type OtherMembership = {
    __typename?: "OtherMembership";
    companyName: Maybe<Scalars["String"]>;
    extraText: Maybe<Scalars["String"]>;
    ticker: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    webTicker: Maybe<Scalars["String"]>;
};

/** Override specific fields. */
export type Overrides = {
    __typename?: "Overrides";
    /** Indicates if thumbnail is overriden */
    thumbnail: Maybe<Scalars["Boolean"]>;
};

export type PeopleForCompany = {
    __typename?: "PeopleForCompany";
    boardMembers: Maybe<Array<Maybe<Person>>>;
    executives: Maybe<Array<Maybe<Person>>>;
    totalBoardMembers: Maybe<Scalars["Int"]>;
    totalExecutives: Maybe<Scalars["Int"]>;
};

export enum Periodicity {
    Daily = "daily",
    Monthly = "monthly",
    Quarterly = "quarterly",
    Weekly = "weekly",
    Yearly = "yearly",
}

export type Person = {
    __typename?: "Person";
    awards: Maybe<Awards>;
    bio: Maybe<Scalars["String"]>;
    birthDay: Maybe<Scalars["String"]>;
    birthPlace: Maybe<Scalars["String"]>;
    careerHistory: Maybe<Array<Maybe<Career>>>;
    /** Indicates that current author is a columnist */
    columnist: Maybe<Scalars["Boolean"]>;
    company: Maybe<Company>;
    /**
     * A user with a private company may only have the companyName,
     *         but not the full company profile
     */
    companyName: Maybe<Scalars["String"]>;
    /** Indicates that current author is a contributors */
    contributor: Maybe<Scalars["Boolean"]>;
    /** Indicates that current author is an Editorial Board */
    editorialBoard: Maybe<Scalars["Boolean"]>;
    education: Maybe<Education>;
    /** Facebook Username */
    facebook: Maybe<Scalars["String"]>;
    /** Complete person name. (First + Middle + Last + "Nickname") */
    fullName: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    memberships: Maybe<Memberships>;
    /** Resolved name. If byline exists, it will use byline. */
    name: Maybe<Scalars["String"]>;
    /** Full name without nickname */
    nameWithoutNickName: Maybe<Scalars["String"]>;
    /** Person nickname */
    nickName: Maybe<Scalars["String"]>;
    photoDisplayed: Maybe<Scalars["Boolean"]>;
    /** The slug to the profile page, if the person has one. */
    profileSlug: Maybe<Scalars["String"]>;
    roles: Maybe<Array<Maybe<Scalars["String"]>>>;
    score: Maybe<Scalars["Float"]>;
    security: Maybe<Security>;
    slug: Maybe<Scalars["String"]>;
    stories: Maybe<Array<Maybe<Story>>>;
    summary: Maybe<Scalars["String"]>;
    tenure: Maybe<Scalars["String"]>;
    thumbnail: Maybe<Image>;
    title: Maybe<Scalars["String"]>;
    /** Twitter Username */
    twitter: Maybe<Scalars["String"]>;
    /** BSSO user id associated with the person. */
    uuid: Maybe<Scalars["Int"]>;
    webVisibility: Maybe<Scalars["Boolean"]>;
};

export type PersonBioArgs = {
    truncate: InputMaybe<Scalars["Boolean"]>;
};

export type PersonStoriesArgs = {
    author: InputMaybe<Scalars["Int"]>;
    brands: InputMaybe<Array<InputMaybe<Brand>>>;
    contentTagsV2: InputMaybe<Array<InputMaybe<ContentTagsFilter>>>;
    enforceContentCliff: InputMaybe<Scalars["Boolean"]>;
    exclude: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
    followRedirect: InputMaybe<Scalars["Boolean"]>;
    id: InputMaybe<Scalars["String"]>;
    images: InputMaybe<Scalars["Boolean"]>;
    issueId: InputMaybe<Scalars["String"]>;
    limit: InputMaybe<Scalars["Int"]>;
    minScores: InputMaybe<Array<InputMaybe<MinScore>>>;
    newsletterSlug: InputMaybe<Scalars["String"]>;
    order: InputMaybe<SortOrder>;
    page: InputMaybe<Scalars["Int"]>;
    premium: InputMaybe<Scalars["Boolean"]>;
    pressRelease: InputMaybe<Scalars["Boolean"]>;
    primarySites: InputMaybe<Array<InputMaybe<Brand>>>;
    publishedAt: InputMaybe<DateRange>;
    revision: InputMaybe<Scalars["String"]>;
    site: InputMaybe<Site>;
    sites: InputMaybe<Array<InputMaybe<Site>>>;
    slug: InputMaybe<Scalars["String"]>;
    sort: InputMaybe<Scalars["String"]>;
    sponsoredCampaignId: InputMaybe<Scalars["String"]>;
    types: InputMaybe<Array<InputMaybe<StoryType>>>;
    updatedAt: InputMaybe<DateRange>;
    variation: InputMaybe<Scalars["String"]>;
};

export type PersonThumbnailArgs = {
    height?: InputMaybe<Scalars["Int"]>;
    imageQuality: InputMaybe<Scalars["Int"]>;
    skipViewMapHeadshot?: InputMaybe<Scalars["Boolean"]>;
    width?: InputMaybe<Scalars["Int"]>;
};

export type PersonTwitterArgs = {
    preferWebTwitter: InputMaybe<Scalars["Boolean"]>;
};

export enum PersonRole {
    Columnist = "COLUMNIST",
    Editor = "EDITOR",
}

export type Publication = {
    __typename?: "Publication";
    date: Maybe<Scalars["String"]>;
    extraText: Maybe<Scalars["String"]>;
    journal: Maybe<Scalars["String"]>;
};

export enum PublishedState {
    Draft = "DRAFT",
    Published = "PUBLISHED",
}

export type Query = {
    __typename?: "Query";
    abbaTargets: Maybe<Scalars["String"]>;
    alerts: Maybe<Array<Maybe<Alert>>>;
    audios: Maybe<Array<Maybe<Audio>>>;
    authorSession: Maybe<AuthorSession>;
    authorSessionList: Maybe<AuthorSessionList>;
    charts: Maybe<Array<Maybe<Chart>>>;
    curation: Maybe<Curation>;
    documents: Maybe<Array<Maybe<Document>>>;
    drafts: Maybe<Array<Maybe<Story>>>;
    exchangeMostActive: Maybe<Array<Maybe<Security>>>;
    fxFixings: Maybe<Array<Maybe<FxFixings>>>;
    images: Maybe<Array<Maybe<Image>>>;
    lineupCuration: Maybe<LineupCuration>;
    lineupModule: Maybe<CurationModule>;
    liveSchedules: Maybe<Array<Maybe<LiveSchedule>>>;
    liveblog: Maybe<Liveblog>;
    magazines: Maybe<Array<Maybe<Magazine>>>;
    newsletter: Maybe<Newsletter>;
    people: Maybe<Array<Maybe<Person>>>;
    peopleForCompany: Maybe<PeopleForCompany>;
    pressReleases: Maybe<Array<Maybe<Story>>>;
    ratePlan: Maybe<RatePlan>;
    record: Maybe<Record>;
    regionalIndices: Maybe<Array<Maybe<RegionalIndices>>>;
    sectors: Maybe<Sector>;
    securities: Maybe<Array<Maybe<Security>>>;
    securityCategory: Maybe<SecurityCategory>;
    sre: Maybe<Array<Maybe<Story>>>;
    stories: Maybe<Array<Maybe<Story>>>;
    storyFilter: Maybe<Array<Maybe<Story>>>;
    storyForSecurity: Maybe<Array<Maybe<Story>>>;
    storyForSecurityType: Maybe<Array<Maybe<Story>>>;
    tags: Maybe<Array<Maybe<Tag>>>;
    targets: Maybe<Array<Maybe<Target>>>;
    translations: Maybe<ContextItem>;
    videos: Maybe<Array<Maybe<Video>>>;
};

export type QueryAbbaTargetsArgs = {
    identifier: InputMaybe<Scalars["String"]>;
    platform: InputMaybe<Scalars["String"]>;
};

export type QueryAudiosArgs = {
    id: Array<InputMaybe<Scalars["String"]>>;
};

export type QueryAuthorSessionArgs = {
    id: InputMaybe<Scalars["String"]>;
    slug: InputMaybe<Scalars["String"]>;
};

export type QueryChartsArgs = {
    id: Scalars["String"];
};

export type QueryCurationArgs = {
    page: InputMaybe<Scalars["String"]>;
    site: Site;
    state: InputMaybe<PublishedState>;
};

export type QueryDocumentsArgs = {
    idType: InputMaybe<IdType>;
    ids: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type QueryDraftsArgs = {
    id: Scalars["String"];
    site: Site;
    type: InputMaybe<ContentType>;
};

export type QueryExchangeMostActiveArgs = {
    direction: ExchangeMoversDirection;
    exchange: Scalars["String"];
    limit: InputMaybe<Scalars["Int"]>;
    locale: InputMaybe<Locale>;
    marketCapMax: InputMaybe<Scalars["String"]>;
    marketCapMin: InputMaybe<Scalars["String"]>;
    sector: InputMaybe<SectorType>;
    tableType: ExchangeMoversTableType;
    timeframe: InputMaybe<ExchangeMoversPeriod>;
};

export type QueryFxFixingsArgs = {
    currencies: Scalars["String"];
    dateTime: Scalars["String"];
    delay: InputMaybe<Scalars["Int"]>;
    locale: InputMaybe<Locale>;
};

export type QueryImagesArgs = {
    assetsUrl: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
    height: InputMaybe<Scalars["Int"]>;
    id: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
    idType: InputMaybe<IdType>;
    imageQuality: InputMaybe<Scalars["Int"]>;
    includeImageBlobMetadata: InputMaybe<Scalars["Boolean"]>;
    includePhotoCredit: InputMaybe<Scalars["Boolean"]>;
    width: InputMaybe<Scalars["Int"]>;
};

export type QueryLineupCurationArgs = {
    page: InputMaybe<Scalars["String"]>;
    site: Site;
    state: InputMaybe<PublishedState>;
};

export type QueryLineupModuleArgs = {
    id: Scalars["String"];
    page: InputMaybe<Scalars["String"]>;
    paginationOffset: InputMaybe<Scalars["Int"]>;
    siteForModule: SiteForModule;
    state: InputMaybe<PublishedState>;
};

export type QueryLiveSchedulesArgs = {
    channel: Scalars["String"];
    endTime: InputMaybe<Scalars["String"]>;
    startTime: InputMaybe<Scalars["String"]>;
};

export type QueryLiveblogArgs = {
    id: Scalars["String"];
};

export type QueryMagazinesArgs = {
    brand: InputMaybe<Array<InputMaybe<MagazineBrand>>>;
    id: InputMaybe<Scalars["String"]>;
    limit: InputMaybe<Scalars["Int"]>;
};

export type QueryNewsletterArgs = {
    slug: InputMaybe<Scalars["String"]>;
};

export type QueryPeopleArgs = {
    id: InputMaybe<Scalars["String"]>;
    role: InputMaybe<PersonRole>;
    site: InputMaybe<Site>;
    slug: InputMaybe<Scalars["String"]>;
};

export type QueryPeopleForCompanyArgs = {
    bbid: InputMaybe<Scalars["String"]>;
    peopleToExpand: InputMaybe<Scalars["Int"]>;
};

export type QueryPressReleasesArgs = {
    field: TimeSearchFields;
    period: Scalars["Int"];
    ticker: InputMaybe<Scalars["String"]>;
    units: TimeUnits;
};

export type QueryRatePlanArgs = {
    ratePlanId: Scalars["String"];
    targetCountry: InputMaybe<Scalars["String"]>;
};

export type QueryRecordArgs = {
    collectionKey: InputMaybe<Scalars["String"]>;
    latest: InputMaybe<Scalars["Boolean"]>;
    slug: InputMaybe<Scalars["String"]>;
};

export type QueryRegionalIndicesArgs = {
    entityType: InputMaybe<GeoEntityType>;
    locale: InputMaybe<Locale>;
    location: Scalars["String"];
    onlyPopular: InputMaybe<Scalars["Boolean"]>;
};

export type QuerySecuritiesArgs = {
    id: Scalars["String"];
    includeRealtimeMetadata: InputMaybe<Scalars["Boolean"]>;
    locale: InputMaybe<Locale>;
    type: InputMaybe<TickerType>;
};

export type QuerySecurityCategoryArgs = {
    id: Scalars["String"];
};

export type QuerySreArgs = {
    limit: InputMaybe<Scalars["Int"]>;
    sre: Scalars["String"];
};

export type QueryStoriesArgs = {
    author: InputMaybe<Scalars["Int"]>;
    brands: InputMaybe<Array<InputMaybe<Brand>>>;
    contentTagsV2: InputMaybe<Array<InputMaybe<ContentTagsFilter>>>;
    enforceContentCliff: InputMaybe<Scalars["Boolean"]>;
    exclude: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
    followRedirect: InputMaybe<Scalars["Boolean"]>;
    id: InputMaybe<Scalars["String"]>;
    images: InputMaybe<Scalars["Boolean"]>;
    issueId: InputMaybe<Scalars["String"]>;
    limit: InputMaybe<Scalars["Int"]>;
    minScores: InputMaybe<Array<InputMaybe<MinScore>>>;
    newsletterSlug: InputMaybe<Scalars["String"]>;
    order: InputMaybe<SortOrder>;
    page: InputMaybe<Scalars["Int"]>;
    premium: InputMaybe<Scalars["Boolean"]>;
    pressRelease: InputMaybe<Scalars["Boolean"]>;
    primarySites: InputMaybe<Array<InputMaybe<Brand>>>;
    publishedAt: InputMaybe<DateRange>;
    revision: InputMaybe<Scalars["String"]>;
    site: InputMaybe<Site>;
    sites: InputMaybe<Array<InputMaybe<Site>>>;
    slug: InputMaybe<Scalars["String"]>;
    sort: InputMaybe<Scalars["String"]>;
    sponsoredCampaignId: InputMaybe<Scalars["String"]>;
    types: InputMaybe<Array<InputMaybe<StoryType>>>;
    updatedAt: InputMaybe<DateRange>;
    variation: InputMaybe<Scalars["String"]>;
};

export type QueryStoryFilterArgs = {
    field: TimeSearchFields;
    filter: Scalars["String"];
    limit: InputMaybe<Scalars["Int"]>;
    period: TimeUnits;
    sortBy: InputMaybe<TimeSearchFields>;
    sortOrder: InputMaybe<SortOrder>;
    units: Scalars["Int"];
};

export type QueryStoryForSecurityArgs = {
    executionMode: InputMaybe<ExecutionMode>;
    field: TimeSearchFields;
    limit: InputMaybe<Scalars["Int"]>;
    locale: LocaleType;
    order: InputMaybe<SortOrder>;
    page: InputMaybe<Scalars["Int"]>;
    period: Scalars["Int"];
    sort: InputMaybe<TimeSearchFields>;
    ticker: Scalars["String"];
    types: InputMaybe<StoryType>;
    units: TimeUnits;
};

export type QueryStoryForSecurityTypeArgs = {
    executionMode: InputMaybe<ExecutionMode>;
    field: TimeSearchFields;
    limit: InputMaybe<Scalars["Int"]>;
    locale: LocaleType;
    order: InputMaybe<SortOrder>;
    period: Scalars["Int"];
    sites: InputMaybe<Array<InputMaybe<Site>>>;
    skipStoryDetailFetch?: InputMaybe<Scalars["Boolean"]>;
    sort: InputMaybe<TimeSearchFields>;
    ticker: Scalars["String"];
    types: InputMaybe<StoryType>;
    units: TimeUnits;
};

export type QueryTagsArgs = {
    id: InputMaybe<Scalars["String"]>;
    limit: InputMaybe<Scalars["Int"]>;
    order: InputMaybe<Scalars["String"]>;
    site: InputMaybe<Site>;
    slug: InputMaybe<Scalars["String"]>;
    sort: InputMaybe<Scalars["String"]>;
    type: InputMaybe<Scalars["String"]>;
};

export type QueryTargetsArgs = {
    identifier: InputMaybe<Scalars["String"]>;
    platform: InputMaybe<Scalars["String"]>;
};

export type QueryTranslationsArgs = {
    contextId: Scalars["String"];
    labels: Scalars["String"];
    languages: Scalars["String"];
};

export type QueryVideosArgs = {
    excludeBadAssets?: InputMaybe<Scalars["Boolean"]>;
    id: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
    idString: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
    idType: InputMaybe<IdType>;
    includeRenditions: InputMaybe<Scalars["Boolean"]>;
    includeTranscript: InputMaybe<Scalars["Boolean"]>;
    transcriptLanguages?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type Rsf = {
    __typename?: "RSF";
    html: Maybe<Scalars["String"]>;
    raw: Maybe<Scalars["String"]>;
    text: Maybe<Scalars["String"]>;
};

export type RsfHtmlArgs = {
    allowBbgLinks: InputMaybe<Scalars["Boolean"]>;
    imageQuality: InputMaybe<Scalars["Int"]>;
};

export type RatePlan = {
    __typename?: "RatePlan";
    IncludesPrint: Maybe<Scalars["Boolean"]>;
    InitialDuration: Maybe<Scalars["String"]>;
    InitialLength: Maybe<Scalars["String"]>;
    TermType: Maybe<Scalars["String"]>;
    allCurrencyCharges: Maybe<Array<Maybe<RatePlanCharge>>>;
    billingPeriod: Maybe<Scalars["String"]>;
    charges: Maybe<RatePlanCharge>;
    description: Maybe<RatePlanDescriptor>;
    effectiveEndDate: Maybe<Scalars["String"]>;
    effectiveStartDate: Maybe<Scalars["String"]>;
    name: Maybe<RatePlanDescriptor>;
    offerType: Maybe<Scalars["String"]>;
    productDescription: Maybe<Scalars["String"]>;
    productId: Maybe<Scalars["String"]>;
    productName: Maybe<Scalars["String"]>;
    promotionId: Maybe<Scalars["Int"]>;
    promotionType: Maybe<Scalars["String"]>;
    ratePlanId: Maybe<Scalars["String"]>;
    ratePlanName: Maybe<Scalars["String"]>;
    status: Maybe<Scalars["String"]>;
    success: Maybe<Scalars["Boolean"]>;
    tiers: Maybe<RatePlanTier>;
};

export type RatePlanCharge = {
    __typename?: "RatePlanCharge";
    currency: Maybe<Scalars["String"]>;
    discount: Maybe<Array<Maybe<RatePlanDiscount>>>;
    hasDiscount: Maybe<Scalars["Boolean"]>;
    hasSurcharge: Maybe<Scalars["Boolean"]>;
    surcharge: Maybe<Array<Maybe<RatePlanSurcharge>>>;
    targetCountries: Maybe<Array<Maybe<Scalars["String"]>>>;
    total: Maybe<Scalars["Float"]>;
    totalDiscount: Maybe<Scalars["Float"]>;
    totalWithDiscount: Maybe<Scalars["Float"]>;
};

export type RatePlanDescriptor = {
    __typename?: "RatePlanDescriptor";
    marketing: Maybe<Scalars["String"]>;
    zuora: Maybe<Scalars["String"]>;
};

export type RatePlanDiscount = {
    __typename?: "RatePlanDiscount";
    amount: Maybe<Scalars["Float"]>;
    discountPeriod: Maybe<Scalars["String"]>;
    discountUpToPeriods: Maybe<Scalars["Int"]>;
    type: Maybe<Scalars["String"]>;
};

export type RatePlanSurcharge = {
    __typename?: "RatePlanSurcharge";
    amount: Maybe<Scalars["Float"]>;
    surchargePeriod: Maybe<Scalars["String"]>;
    surchargeUpToPeriods: Maybe<Scalars["Int"]>;
    type: Maybe<Scalars["String"]>;
};

export type RatePlanTier = {
    __typename?: "RatePlanTier";
    charges: Maybe<Array<Maybe<RatePlanTierCharge>>>;
    discount: Maybe<Array<Maybe<RatePlanDiscount>>>;
};

export type RatePlanTierCharge = {
    __typename?: "RatePlanTierCharge";
    endingUnit: Maybe<Scalars["Int"]>;
    price: Maybe<Scalars["Float"]>;
    priceDiscount: Maybe<Scalars["Float"]>;
    priceFormat: Maybe<Scalars["String"]>;
    priceWithDiscount: Maybe<Scalars["Float"]>;
    startingUnit: Maybe<Scalars["Int"]>;
    tier: Maybe<Scalars["Int"]>;
};

export type Reading = {
    __typename?: "Reading";
    durationMs: Maybe<Scalars["Int"]>;
    url: Maybe<Scalars["String"]>;
    voice: Maybe<Scalars["String"]>;
};

/** The Record object type */
export type Record = {
    __typename?: "Record";
    navLinks: Maybe<Array<Maybe<NavLink>>>;
    slug: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    titleLink: Maybe<Scalars["String"]>;
};

export type RegionalIndices = {
    __typename?: "RegionalIndices";
    countryIso: Maybe<Scalars["String"]>;
    highPrice: Maybe<Scalars["Float"]>;
    id: Maybe<Scalars["String"]>;
    lastUpdate: Maybe<Scalars["DateTime"]>;
    longName: Maybe<Scalars["String"]>;
    lowPrice: Maybe<Scalars["Float"]>;
    name: Maybe<Scalars["String"]>;
    openPrice: Maybe<Scalars["Float"]>;
    percentChange1Day: Maybe<Scalars["Float"]>;
    percentChange1Month: Maybe<Scalars["Float"]>;
    percentChange1Year: Maybe<Scalars["Float"]>;
    price: Maybe<Scalars["Float"]>;
    priceChange1Day: Maybe<Scalars["Float"]>;
};

export type RelatedStories = {
    __typename?: "RelatedStories";
    news: Maybe<Array<Maybe<Story>>>;
    opinion: Maybe<Array<Maybe<Story>>>;
};

export type School = {
    __typename?: "School";
    degree: Maybe<Scalars["String"]>;
    school: Maybe<Scalars["String"]>;
};

export type Sector = {
    __typename?: "Sector";
    children: Maybe<Array<Maybe<Sector>>>;
    id: Maybe<Scalars["Int"]>;
    name: Maybe<Scalars["String"]>;
    percentChange1Day: Maybe<Scalars["Float"]>;
    /** ticker associated with entity */
    security: Maybe<Scalars["String"]>;
    /** weight among all industries, not just in parent sector */
    weight: Maybe<Scalars["Float"]>;
};

export enum SectorType {
    All = "ALL",
    BasicMaterials = "BASIC_MATERIALS",
    Communications = "COMMUNICATIONS",
    ConsumerCyclical = "CONSUMER_CYCLICAL",
    ConsumerNoncyclical = "CONSUMER_NONCYCLICAL",
    Diversified = "DIVERSIFIED",
    Energy = "ENERGY",
    Financial = "FINANCIAL",
    Industrial = "INDUSTRIAL",
    Technology = "TECHNOLOGY",
    Utilities = "UTILITIES",
}

export type Security = {
    __typename?: "Security";
    averageDaysToMaturity: Maybe<Scalars["Float"]>;
    averageVolume30Day: Maybe<Scalars["Float"]>;
    backLoadFee: Maybe<Scalars["Float"]>;
    bbid: Maybe<Scalars["String"]>;
    bicsIndustry: Maybe<Scalars["String"]>;
    bicsSector: Maybe<Scalars["String"]>;
    bicsSubIndustry: Maybe<Scalars["String"]>;
    boardMembers: Maybe<Array<Maybe<Person>>>;
    coFundManager: Maybe<Scalars["String"]>;
    commodityContractDate: Maybe<Scalars["String"]>;
    commodityUnits: Maybe<Scalars["String"]>;
    companyAddress: Maybe<Scalars["String"]>;
    companyDescription: Maybe<Scalars["String"]>;
    companyIsPrivate: Maybe<Scalars["Boolean"]>;
    companyPhone: Maybe<Scalars["String"]>;
    companyWebsite: Maybe<Scalars["String"]>;
    countryIso: Maybe<Scalars["String"]>;
    countryIssueIso: Maybe<Scalars["String"]>;
    coupon: Maybe<Scalars["Float"]>;
    currentManagementFee: Maybe<Scalars["Float"]>;
    dividend: Maybe<Scalars["Float"]>;
    earningsAnnouncement: Maybe<Scalars["String"]>;
    earningsPerShare: Maybe<Scalars["Float"]>;
    estimatedEarningsPerShareCurrentYear: Maybe<Scalars["Float"]>;
    estimatedPriceEarningsRatioCurrentYear: Maybe<Scalars["Float"]>;
    estimatedPriceEarningsToGrowthRatio: Maybe<Scalars["Float"]>;
    exchangeCode: Maybe<Scalars["String"]>;
    exchangeDelay: Maybe<Scalars["String"]>;
    exchangeId: Maybe<Scalars["String"]>;
    executives: Maybe<Array<Maybe<Person>>>;
    expenseRatio: Maybe<Scalars["Float"]>;
    foundedDate: Maybe<Scalars["String"]>;
    foundedYear: Maybe<Scalars["String"]>;
    frontLoadFee: Maybe<Scalars["Float"]>;
    fundAssetClassFocus: Maybe<Scalars["String"]>;
    fundGeographicFocus: Maybe<Scalars["String"]>;
    fundManager: Maybe<Scalars["String"]>;
    fundMarketingFee: Maybe<Scalars["Float"]>;
    fundObjective: Maybe<Scalars["String"]>;
    fundTopHoldings: Maybe<Array<Maybe<FundHolding>>>;
    fundType: Maybe<Scalars["String"]>;
    fundamentalDataCurrency: Maybe<Scalars["String"]>;
    futuresContractDate: Maybe<Scalars["String"]>;
    gicsIndustry: Maybe<Scalars["Float"]>;
    gicsSector: Maybe<Scalars["Float"]>;
    highPrice: Maybe<Scalars["Float"]>;
    highPrice52Week: Maybe<Scalars["Float"]>;
    /** Fetch history data */
    historySeries: Maybe<Array<Maybe<DateTimeValue>>>;
    id: Maybe<Scalars["String"]>;
    inceptionDate: Maybe<Scalars["DateTime"]>;
    indexDescription: Maybe<Scalars["String"]>;
    indexMembers: Maybe<Array<Maybe<Security>>>;
    indexMovers: Maybe<Array<Maybe<Security>>>;
    indexSource: Maybe<Scalars["String"]>;
    indicatedGrossDividendYield: Maybe<Scalars["Float"]>;
    /** Fetch intraday data */
    intradaySeries: Maybe<IntradaySeriesValue>;
    inverseQuotedIndicator: Maybe<Scalars["Boolean"]>;
    isExchangeDelayed: Maybe<Scalars["Boolean"]>;
    isOpen: Maybe<Scalars["Boolean"]>;
    issuedCurrency: Maybe<Scalars["String"]>;
    issuedUnits: Maybe<Scalars["String"]>;
    issuerEquityTicker: Maybe<Scalars["String"]>;
    lastAnnouncementPeriod: Maybe<Scalars["String"]>;
    lastDividendReported: Maybe<Scalars["String"]>;
    lastPostSessionPrice: Maybe<Scalars["Float"]>;
    lastPreSessionPrice: Maybe<Scalars["Float"]>;
    lastUpdate: Maybe<Scalars["DateTime"]>;
    lastYield: Maybe<Scalars["Float"]>;
    locale: Maybe<Scalars["String"]>;
    longName: Maybe<Scalars["String"]>;
    lowPrice: Maybe<Scalars["Float"]>;
    lowPrice52Week: Maybe<Scalars["Float"]>;
    marketCap: Maybe<Scalars["Float"]>;
    marketStatus: Maybe<Scalars["String"]>;
    mediaSecuritySubtype: Maybe<Scalars["String"]>;
    mediaSecurityType: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    netAssetValue: Maybe<Scalars["Float"]>;
    netAssetValueDate: Maybe<Scalars["DateTime"]>;
    netChange1DayPostSessionRegular: Maybe<Scalars["Float"]>;
    netChange1DayPreSessionRegular: Maybe<Scalars["Float"]>;
    nextEarningsAnnouncement: Maybe<Scalars["String"]>;
    nextEarningsPeriod: Maybe<Scalars["String"]>;
    nextEarningsPeriodEnd: Maybe<Scalars["String"]>;
    numberOfEmployees: Maybe<Scalars["Float"]>;
    /**
     *
     *         This field allows for dynamic attributes in numerical type. Usage:
     *           securities(id: 'SPY:US') {
     *             totalReturn1Year: variable(id: 'totalReturn1Year')
     *           }
     *
     */
    numericalVariable: Maybe<Scalars["Float"]>;
    openPrice: Maybe<Scalars["Float"]>;
    parentTicker: Maybe<Scalars["String"]>;
    parsekeyableDescription: Maybe<Scalars["String"]>;
    percentChange1Day: Maybe<Scalars["Float"]>;
    percentChange1DayPostRegular: Maybe<Scalars["Float"]>;
    percentChange1DayPreRegular: Maybe<Scalars["Float"]>;
    percentChange1Month: Maybe<Scalars["Float"]>;
    percentChange1Year: Maybe<Scalars["Float"]>;
    percentPremium: Maybe<Scalars["Float"]>;
    percentPremium52WeekAverage: Maybe<Scalars["Float"]>;
    periodicity: Maybe<Scalars["String"]>;
    pressReleases: Maybe<Array<Maybe<Story>>>;
    previousClosingPriceOneTradingDayAgo: Maybe<Scalars["Float"]>;
    previousTradingDate: Maybe<Scalars["String"]>;
    price: Maybe<Scalars["Float"]>;
    priceChange1Day: Maybe<Scalars["Float"]>;
    priceEarningsRatio: Maybe<Scalars["Float"]>;
    priceEarningsToGrowthAndDividendYieldRatio: Maybe<Scalars["Float"]>;
    priceMinDecimals: Maybe<Scalars["Int"]>;
    priceToBookRatio: Maybe<Scalars["Float"]>;
    priceToSalesRatio: Maybe<Scalars["Float"]>;
    primaryExchange: Maybe<Scalars["String"]>;
    primarySecurityTicker: Maybe<Scalars["String"]>;
    quoteFactor: Maybe<Scalars["Float"]>;
    ratePrice: Maybe<Scalars["Float"]>;
    ratePrice1YearAgo: Maybe<Scalars["Float"]>;
    realTimeTickerDescription: Maybe<Scalars["String"]>;
    redemptionFee: Maybe<Scalars["Float"]>;
    /**
     *
     *         This field resolves the ISO country code for the ticker to a region
     *         The region names are defined by product requirements.
     *
     */
    region: Maybe<Scalars["String"]>;
    score: Maybe<Scalars["Float"]>;
    securityId: Maybe<Scalars["String"]>;
    securityName: Maybe<Scalars["String"]>;
    securityStatus: Maybe<Scalars["String"]>;
    shareClass: Maybe<Scalars["String"]>;
    sharesOutstanding: Maybe<Scalars["Float"]>;
    shortName: Maybe<Scalars["String"]>;
    subIndustry: Maybe<Scalars["String"]>;
    timeZoneOffset: Maybe<Scalars["Float"]>;
    totalAssets: Maybe<Scalars["Float"]>;
    totalAssetsCurrency: Maybe<Scalars["String"]>;
    totalAssetsDate: Maybe<Scalars["DateTime"]>;
    totalReturn1Year: Maybe<Scalars["Float"]>;
    totalReturn3Month: Maybe<Scalars["Float"]>;
    totalReturn3Year: Maybe<Scalars["Float"]>;
    totalReturn5Year: Maybe<Scalars["Float"]>;
    totalReturnYtd: Maybe<Scalars["Float"]>;
    tradingDate: Maybe<Scalars["String"]>;
    tradingDayClose: Maybe<Scalars["DateTime"]>;
    tradingDayCloseUTC: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
    ultimateParentTicker: Maybe<Scalars["String"]>;
    /**
     *
     *         This field allows for dynamic attributes. Usage:
     *           securities(id: 'SPY:US') {
     *             fundManager: variable(id: 'fundManager')
     *           }
     *
     */
    variable: Maybe<Scalars["String"]>;
    volume: Maybe<Scalars["Float"]>;
    yieldChange1Day: Maybe<Scalars["Float"]>;
    yieldChange1Month: Maybe<Scalars["Float"]>;
    yieldChange1Year: Maybe<Scalars["Float"]>;
};

export type SecurityBoardMembersArgs = {
    includeDetails?: InputMaybe<Scalars["Boolean"]>;
};

export type SecurityExecutivesArgs = {
    includeDetails?: InputMaybe<Scalars["Boolean"]>;
};

export type SecurityHistorySeriesArgs = {
    currency: InputMaybe<Scalars["String"]>;
    endDate: Scalars["String"];
    field: Scalars["String"];
    periodicity: InputMaybe<Periodicity>;
    startDate: Scalars["String"];
};

export type SecurityIndexMembersArgs = {
    size: InputMaybe<Scalars["Int"]>;
};

export type SecurityIndexMoversArgs = {
    criteria: InputMaybe<Criteria>;
};

export type SecurityIntradaySeriesArgs = {
    days: InputMaybe<Scalars["Int"]>;
    field: Scalars["String"];
    interval: InputMaybe<Scalars["Int"]>;
};

export type SecurityNumericalVariableArgs = {
    id: Scalars["String"];
};

export type SecurityPressReleasesArgs = {
    field: TimeSearchFields;
    period: Scalars["Int"];
    ticker: InputMaybe<Scalars["String"]>;
    units: TimeUnits;
};

export type SecurityVariableArgs = {
    id: Scalars["String"];
};

export type SecurityCategory = {
    __typename?: "SecurityCategory";
    id: Maybe<Scalars["String"]>;
    mediaSecuritySubtype: Maybe<Scalars["String"]>;
    mediaSecurityType: Maybe<Scalars["String"]>;
    terminalSecurityType: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
};

export type Show = {
    __typename?: "Show";
    hostBioIds: Maybe<Array<Maybe<Scalars["String"]>>>;
    hosts: Maybe<Array<Maybe<Scalars["String"]>>>;
    showDescription: Maybe<Scalars["String"]>;
    showKeywords: Maybe<Array<Maybe<Scalars["String"]>>>;
    showMrcId: Maybe<Scalars["String"]>;
    showNiCode: Maybe<Array<Maybe<Scalars["String"]>>>;
    showSourceId: Maybe<Scalars["Int"]>;
    showStatusId: Maybe<Scalars["Int"]>;
    showTimeSummary: Maybe<Array<Maybe<Scalars["String"]>>>;
    showTitle: Maybe<Scalars["String"]>;
    thumbnail: Maybe<Image>;
};

export type ShowInfo = {
    __typename?: "ShowInfo";
    /** Show Id */
    id: Maybe<Scalars["String"]>;
    /** Show display name */
    name: Maybe<Scalars["String"]>;
};

export enum Site {
    AppleNews = "APPLE_NEWS",
    Business = "BUSINESS",
    Businessweek = "BUSINESSWEEK",
    BusinessWeekApp = "BUSINESS_WEEK_APP",
    Citylab = "CITYLAB",
    ClimateChanged = "CLIMATE_CHANGED",
    Cojp = "COJP",
    Cybersecurity = "CYBERSECURITY",
    Equality = "EQUALITY",
    Feeds = "FEEDS",
    Gadfly = "GADFLY",
    Green = "GREEN",
    Hyperdrive = "HYPERDRIVE",
    Markets = "MARKETS",
    MarketsMagazine = "MARKETS_MAGAZINE",
    Mobile = "MOBILE",
    Newsletters = "NEWSLETTERS",
    NewEconomyForum = "NEW_ECONOMY_FORUM",
    Opinion = "OPINION",
    Politics = "POLITICS",
    Prognosis = "PROGNOSIS",
    Pursuits = "PURSUITS",
    Quicktake = "QUICKTAKE",
    Screentime = "SCREENTIME",
    Socialflow = "SOCIALFLOW",
    SpecialIssue = "SPECIAL_ISSUE",
    Sponsored = "SPONSORED",
    Syndication = "SYNDICATION",
    Technology = "TECHNOLOGY",
    Tictoc = "TICTOC",
    Tv = "TV",
    View = "VIEW",
    Wealth = "WEALTH",
    WeekendEdition = "WEEKEND_EDITION",
    World = "WORLD",
}

export enum SiteForModule {
    AppleNews = "APPLE_NEWS",
    Business = "BUSINESS",
    Businessweek = "BUSINESSWEEK",
    BusinessWeekApp = "BUSINESS_WEEK_APP",
    Citylab = "CITYLAB",
    Cojp = "COJP",
    Equality = "EQUALITY",
    Feeds = "FEEDS",
    Gadfly = "GADFLY",
    Green = "GREEN",
    Markets = "MARKETS",
    MarketsMagazine = "MARKETS_MAGAZINE",
    Mobile = "MOBILE",
    Newsletters = "NEWSLETTERS",
    Politics = "POLITICS",
    Pursuits = "PURSUITS",
    Quicktake = "QUICKTAKE",
    Socialflow = "SOCIALFLOW",
    Technology = "TECHNOLOGY",
    Tv = "TV",
    View = "VIEW",
    Wealth = "WEALTH",
    WeekendEdition = "WEEKEND_EDITION",
    World = "WORLD",
}

export type Social = {
    __typename?: "Social";
    /** Body for Social Card. i.e. og:description */
    body: Maybe<Scalars["String"]>;
    /** Thumbnail for Social Card. i.e. og:image */
    image: Maybe<Image>;
    /** Text to be displayed in social post. i.e. facebook:status */
    shareText: Maybe<Scalars["String"]>;
    /** Title for Social Card. .i.e. og:title */
    title: Maybe<Scalars["String"]>;
};

export type SocialImageArgs = {
    height: InputMaybe<Scalars["Int"]>;
    width: InputMaybe<Scalars["Int"]>;
};

export enum SortOrder {
    Asc = "ASC",
    Desc = "DESC",
}

/** Default Content Type */
export type Story = {
    __typename?: "Story";
    abstract: Maybe<Array<Maybe<Scalars["String"]>>>;
    adIds: Maybe<Array<Maybe<Scalars["String"]>>>;
    adTargeting: Maybe<AdTargeting>;
    /** Indicate whether or not this Story needs to be behind the content cliff */
    archived: Maybe<Scalars["Boolean"]>;
    /**
     * If the story byline is "Bloomberg News", returns the credits with role
     *       by, reporter, contributor, or assist.  Any other byline only returns assist role.
     */
    assistance: Maybe<Array<Maybe<Person>>>;
    attributor: Maybe<Scalars["String"]>;
    audios: Maybe<Array<Maybe<Audio>>>;
    /** Author Session metadata for Engaging with Authors live event. */
    authorSession: Maybe<AuthorSession>;
    authoredRegion: Maybe<Scalars["String"]>;
    autoGeneratedSummary: Maybe<Metatext>;
    autoSummaries: Maybe<Array<Maybe<AutoSummary>>>;
    body: Maybe<Rsf>;
    /** primary brand the story is associated with (mapped from primary site) */
    brand: Maybe<Scalars["String"]>;
    byline: Maybe<Scalars["String"]>;
    campaign: Maybe<Campaign>;
    categories: Maybe<Array<Maybe<Scalars["String"]>>>;
    charts: Maybe<Array<Maybe<Chart>>>;
    checksum: Maybe<Scalars["String"]>;
    collections: Maybe<Collections>;
    contentTags: Maybe<Array<Maybe<ContentTag>>>;
    corrected: Maybe<Scalars["Boolean"]>;
    /** Override the image credit in the image */
    creditCurationOverride: Maybe<Scalars["String"]>;
    credits: Maybe<Array<Maybe<Person>>>;
    curatedAt: Maybe<Scalars["DateTime"]>;
    disableAds: Maybe<Scalars["Boolean"]>;
    disclaimer: Maybe<Rsf>;
    docXml: Maybe<Scalars["String"]>;
    documents: Maybe<Array<Maybe<Document>>>;
    /** URL for an embedded webpage attachment */
    embedUrl: Maybe<Scalars["String"]>;
    extraTags: Maybe<ExtraTags>;
    facebook: Maybe<Social>;
    featureVersion: Maybe<Scalars["Int"]>;
    footer: Maybe<Rsf>;
    footnotes: Maybe<Rsf>;
    /** franchise the story is associated with */
    franchise: Maybe<Scalars["String"]>;
    header: Maybe<Rsf>;
    headline: Maybe<Metatext>;
    hedAndDekPosition: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    iframes: Maybe<Array<Maybe<Iframe>>>;
    images: Maybe<Array<Maybe<Image>>>;
    indexes: Maybe<Array<Maybe<Security>>>;
    isTrending: Maybe<Scalars["Boolean"]>;
    issueId: Maybe<Scalars["String"]>;
    /** Set to prefer liveblog keypoints when liveblog posts would be displayed by default */
    keypointsToggle: Maybe<Scalars["Boolean"]>;
    label: Maybe<Scalars["String"]>;
    /** Text value for label from list in edit dash for lineup */
    labelDropdown: Maybe<Scalars["String"]>;
    language: Maybe<Scalars["String"]>;
    lede: Maybe<Lede>;
    ledeKind: Maybe<Scalars["String"]>;
    /** Text value for the kind of livestream */
    livestream: Maybe<Scalars["String"]>;
    magazine: Maybe<MagazineStoryData>;
    magazineIssue: Maybe<Magazine>;
    meta: Maybe<Meta>;
    metadata: Maybe<Metadata>;
    minorUpdatedAt: Maybe<Scalars["DateTime"]>;
    mobileLede: Maybe<Image>;
    /** Indicates whether the Story has a new slug that is different than the one used in the query. This is used to determine whether a frontend app should redirect a client. The query must be slug based and explicitly set the "followRedirect" argument to false. */
    moved: Maybe<Scalars["Boolean"]>;
    newsletter: Maybe<Newsletter>;
    nicodes: Maybe<Array<Maybe<NiCodes>>>;
    /** Original flattened credits list without parsing HTML */
    originalCredits: Maybe<Array<Maybe<Person>>>;
    /** Indicator of fields overriden by Editdash */
    overrides: Maybe<Overrides>;
    people: Maybe<Array<Maybe<Person>>>;
    /** pillar the story is associated with */
    pillar: Maybe<Scalars["String"]>;
    /** Indicates whether the Story is premium (subscription only) content. */
    premium: Maybe<Scalars["Boolean"]>;
    primaryCategory: Maybe<Scalars["String"]>;
    publishedAt: Maybe<Scalars["DateTime"]>;
    reaction: Maybe<Scalars["String"]>;
    readings: Maybe<Array<Maybe<Reading>>>;
    related: Maybe<RelatedStories>;
    /** Optional title for related items */
    relatedTitle: Maybe<Scalars["String"]>;
    /** The resource type of the story used across different application in media, e.g., personalization,tracking,tagger,notification */
    resourceType: Maybe<Scalars["String"]>;
    revision: Maybe<Scalars["String"]>;
    /** non-primary brands the story is associated with (derived from sites) */
    secondaryBrands: Maybe<Array<Maybe<Scalars["String"]>>>;
    shortUrl: Maybe<Scalars["String"]>;
    show: Maybe<ShowInfo>;
    /** primary site the story is associated with (maps to primary brand) */
    site: Maybe<Scalars["String"]>;
    /** all sites the story is associated with (map to brands and franchises) */
    sites: Maybe<Array<Maybe<Scalars["String"]>>>;
    slug: Maybe<Scalars["String"]>;
    /** Time range of price movements for interactive chart to show (e.g. ONE_MONTH) */
    snapshotDuration: Maybe<Scalars["String"]>;
    /** End date for a chart intraday series */
    snapshotEndDate: Maybe<Scalars["String"]>;
    /** Start date for a chart intraday series */
    snapshotStartDate: Maybe<Scalars["String"]>;
    /** Terminal ticker to display an interactive chart with the story (e.g. TSLA:US) */
    snapshotTicker: Maybe<Scalars["String"]>;
    /** Optional headline for the snapshot chart */
    snapshotTitle: Maybe<Scalars["String"]>;
    /** story threads that contain this story */
    storythreads: Maybe<Array<Maybe<Story>>>;
    subheadline: Maybe<Scalars["String"]>;
    summary: Maybe<Metatext>;
    tags: Maybe<Array<Maybe<Tag>>>;
    template: Maybe<Scalars["String"]>;
    terminalTickers: Maybe<Array<Maybe<Tag>>>;
    /** Text overwrite value for item labels in lineup. */
    textLabel: Maybe<Scalars["String"]>;
    thumbnail: Maybe<Image>;
    tickers: Maybe<Array<Maybe<Security>>>;
    timeline: Maybe<Rsf>;
    topic: Maybe<Tag>;
    trashline: Maybe<Rsf>;
    twitter: Maybe<Social>;
    type: Maybe<Scalars["String"]>;
    updatedAt: Maybe<Scalars["DateTime"]>;
    url: Maybe<Scalars["String"]>;
    /** item-level display distinction. */
    variation: Maybe<Scalars["String"]>;
    /** Video added to the story item in Edit Dash */
    videoCurationOverride: Maybe<Video>;
    videos: Maybe<Array<Maybe<Video>>>;
    webOriginal: Maybe<Scalars["Boolean"]>;
    widget: Maybe<Widget>;
    wire: Maybe<Wire>;
    /** Returns story word count */
    wordCount: Maybe<Scalars["Int"]>;
};

/** Default Content Type */
export type StoryBodyArgs = {
    setIframes: InputMaybe<Scalars["Boolean"]>;
};

/** Default Content Type */
export type StoryContentTagsArgs = {
    limit: InputMaybe<Scalars["Int"]>;
    minScores: InputMaybe<Array<InputMaybe<MinScore>>>;
    sort: InputMaybe<Scalars["Boolean"]>;
    sortV2: InputMaybe<ContentTagsSort>;
    types: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

/** Default Content Type */
export type StoryFacebookArgs = {
    imageQuality: InputMaybe<Scalars["Int"]>;
};

/** Default Content Type */
export type StoryImagesArgs = {
    imageQuality: InputMaybe<Scalars["Int"]>;
    includeImageBlobMetadata: InputMaybe<Scalars["Boolean"]>;
    includePhotoCredit: InputMaybe<Scalars["Boolean"]>;
    themedOnly: InputMaybe<Scalars["Boolean"]>;
};

/** Default Content Type */
export type StoryIndexesArgs = {
    limit: InputMaybe<Scalars["Int"]>;
    order: InputMaybe<SortOrder>;
    score: InputMaybe<FloatRange>;
    sort: InputMaybe<Scalars["String"]>;
};

/** Default Content Type */
export type StoryLedeArgs = {
    imageQuality: InputMaybe<Scalars["Int"]>;
};

/** Default Content Type */
export type StoryMobileLedeArgs = {
    imageQuality: InputMaybe<Scalars["Int"]>;
};

/** Default Content Type */
export type StoryNicodesArgs = {
    limit: InputMaybe<Scalars["Int"]>;
    order: InputMaybe<SortOrder>;
    score: InputMaybe<FloatRange>;
    sort: InputMaybe<Scalars["String"]>;
};

/** Default Content Type */
export type StoryPeopleArgs = {
    limit: InputMaybe<Scalars["Int"]>;
    order: InputMaybe<SortOrder>;
    score: InputMaybe<FloatRange>;
    sort: InputMaybe<Scalars["String"]>;
};

/** Default Content Type */
export type StorySummaryArgs = {
    displayOverridesOnlyForVideo?: InputMaybe<Scalars["Boolean"]>;
};

/** Default Content Type */
export type StoryTagsArgs = {
    limit: InputMaybe<Scalars["Int"]>;
    order: InputMaybe<SortOrder>;
    score: InputMaybe<FloatRange>;
    sort: InputMaybe<Scalars["String"]>;
};

/** Default Content Type */
export type StoryTerminalTickersArgs = {
    limit: InputMaybe<Scalars["Int"]>;
    minScore: InputMaybe<Scalars["Int"]>;
};

/** Default Content Type */
export type StoryThumbnailArgs = {
    imageQuality: InputMaybe<Scalars["Int"]>;
    includePhotoCredit?: InputMaybe<Scalars["Boolean"]>;
    useAttachmentThumbnail?: InputMaybe<Scalars["Boolean"]>;
    usePersonalizationThumbnail?: InputMaybe<Scalars["Boolean"]>;
};

/** Default Content Type */
export type StoryTickersArgs = {
    limit: InputMaybe<Scalars["Int"]>;
    order: InputMaybe<SortOrder>;
    score: InputMaybe<FloatRange>;
    sort: InputMaybe<Scalars["String"]>;
};

/** Default Content Type */
export type StoryVideosArgs = {
    excludeBadAssets?: InputMaybe<Scalars["Boolean"]>;
    includeRenditions: InputMaybe<Scalars["Boolean"]>;
    includeTranscript: InputMaybe<Scalars["Boolean"]>;
    transcriptLanguages?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
    useAttachmentVideo?: InputMaybe<Scalars["Boolean"]>;
};

export enum StoryType {
    Article = "ARTICLE",
    AuthorSession = "AUTHOR_SESSION",
    Breaking = "BREAKING",
    Data = "DATA",
    Explainers = "EXPLAINERS",
    Feature = "FEATURE",
    ImpactScorecard = "IMPACT_SCORECARD",
    Interactive = "INTERACTIVE",
    Letter = "LETTER",
    NewsletterCampaign = "NEWSLETTER_CAMPAIGN",
    Quicktake = "QUICKTAKE",
    Slideshow = "SLIDESHOW",
    Video = "VIDEO",
}

export type Tag = {
    __typename?: "Tag";
    id: Maybe<Scalars["String"]>;
    kind: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    score: Maybe<Scalars["Float"]>;
    slug: Maybe<Scalars["String"]>;
    stories: Maybe<Array<Maybe<Story>>>;
};

export type TagStoriesArgs = {
    author: InputMaybe<Scalars["Int"]>;
    brands: InputMaybe<Array<InputMaybe<Brand>>>;
    contentTagsV2: InputMaybe<Array<InputMaybe<ContentTagsFilter>>>;
    enforceContentCliff: InputMaybe<Scalars["Boolean"]>;
    exclude: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
    followRedirect: InputMaybe<Scalars["Boolean"]>;
    id: InputMaybe<Scalars["String"]>;
    images: InputMaybe<Scalars["Boolean"]>;
    issueId: InputMaybe<Scalars["String"]>;
    limit: InputMaybe<Scalars["Int"]>;
    minScores: InputMaybe<Array<InputMaybe<MinScore>>>;
    newsletterSlug: InputMaybe<Scalars["String"]>;
    order: InputMaybe<SortOrder>;
    page: InputMaybe<Scalars["Int"]>;
    premium: InputMaybe<Scalars["Boolean"]>;
    pressRelease: InputMaybe<Scalars["Boolean"]>;
    primarySites: InputMaybe<Array<InputMaybe<Brand>>>;
    publishedAt: InputMaybe<DateRange>;
    revision: InputMaybe<Scalars["String"]>;
    site: InputMaybe<Site>;
    sites: InputMaybe<Array<InputMaybe<Site>>>;
    slug: InputMaybe<Scalars["String"]>;
    sort: InputMaybe<Scalars["String"]>;
    sponsoredCampaignId: InputMaybe<Scalars["String"]>;
    types: InputMaybe<Array<InputMaybe<StoryType>>>;
    updatedAt: InputMaybe<DateRange>;
    variation: InputMaybe<Scalars["String"]>;
};

export enum TagScoreType {
    Derived = "DERIVED",
    Direct = "DIRECT",
}

export type Theme = {
    __typename?: "Theme";
    id: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
};

export enum TickerType {
    Cef = "CEF",
    Com = "COM",
    Cor = "COR",
    Cur = "CUR",
    Eqt = "EQT",
    Etp = "ETP",
    Gov = "GOV",
    Ind = "IND",
    Indc = "INDC",
    Indf = "INDF",
    Indn = "INDN",
    Inds = "INDS",
    Mmf = "MMF",
    Mtg = "MTG",
    Mun = "MUN",
    Oef = "OEF",
    Oefh = "OEFH",
}

export enum TimeSearchFields {
    GroupPublishedAt = "groupPublishedAt",
    StoryPublishedAt = "storyPublishedAt",
    StoryUpdatedAt = "storyUpdatedAt",
}

export enum TimeUnits {
    Days = "days",
    Hours = "hours",
    Minutes = "minutes",
    Months = "months",
    Weeks = "weeks",
    Years = "years",
}

export type Tracking = {
    __typename?: "Tracking";
    id: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};

export type Video = {
    __typename?: "Video";
    aspectRatio: Maybe<AspectRatio>;
    /** Only applicable to lede videos. */
    autoplay: Maybe<Scalars["Boolean"]>;
    avmmIds: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** DEPRECATED! Use 'captions'. */
    caption: Maybe<Scalars["String"]>;
    captions: Maybe<Scalars["String"]>;
    cedexisAppID: Maybe<Scalars["String"]>;
    compressedIds: Maybe<Scalars["String"]>;
    contentLocation: Maybe<Scalars["String"]>;
    createdUnixUTC: Maybe<Scalars["DateTime"]>;
    credit: Maybe<Scalars["String"]>;
    description: Maybe<Scalars["String"]>;
    desktop: Maybe<AssetMedia>;
    duration: Maybe<Scalars["Int"]>;
    excludedInCountries: Maybe<Array<Maybe<Scalars["String"]>>>;
    id: Maybe<Scalars["String"]>;
    /** keywords identify looping videos */
    keywords: Maybe<Array<Maybe<Scalars["String"]>>>;
    mobile: Maybe<AssetMedia>;
    ni: Maybe<Scalars["String"]>;
    prerollAdUnit: Maybe<Scalars["String"]>;
    renditionType: Maybe<Scalars["String"]>;
    renditions: Maybe<Array<Maybe<Video>>>;
    showName: Maybe<Scalars["String"]>;
    story: Maybe<Story>;
    streams: Maybe<Array<Maybe<VideoStream>>>;
    thumbnail: Maybe<Image>;
    title: Maybe<Scalars["String"]>;
    transcript: Maybe<Scalars["String"]>;
    transcriptLanguage: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
};

export type VideoThumbnailArgs = {
    imageQuality: InputMaybe<Scalars["Int"]>;
};

export type VideoStream = {
    __typename?: "VideoStream";
    bitrate: Maybe<Bitrate>;
    codec: Maybe<Codec>;
    format: Maybe<Scalars["String"]>;
    height: Maybe<Scalars["Int"]>;
    percent: Maybe<Scalars["Int"]>;
    size: Maybe<Scalars["Int"]>;
    type: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
    width: Maybe<Scalars["Int"]>;
};

export type Widget = {
    __typename?: "Widget";
    html: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["Int"]>;
    title: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
};

export type Wire = {
    __typename?: "Wire";
    class: Maybe<Scalars["Int"]>;
    id: Maybe<Scalars["Int"]>;
    mnemonic: Maybe<Scalars["String"]>;
};

export type Zone = {
    __typename?: "Zone";
    columns: Maybe<Array<Maybe<Column>>>;
    kind: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
};

/** Mobile alerts for web display */
export type Alert = {
    __typename?: "alert";
    body: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["String"]>;
    image: Maybe<Scalars["String"]>;
    regions: Maybe<Array<Maybe<Scalars["String"]>>>;
    url: Maybe<Scalars["String"]>;
};

/** A/B Targeting and Testing Dashboard target type */
export type Target = {
    __typename?: "target";
    condition: Maybe<Scalars["String"]>;
    config: Maybe<Scalars["String"]>;
    experiments: Maybe<Array<Maybe<AbbaTargetExperiment>>>;
    priority: Maybe<Scalars["Int"]>;
    targetId: Maybe<Scalars["String"]>;
};
